import { AsyncTaskStatus } from 'constants/conceptLinkerValidatorStatus';

export function asyncTaskStatusRenderer(params: { value?: any }) {
  if (params.value === undefined || params.value === null) {
    return '';
  }

  const status = params.value;

  switch (status) {
    case AsyncTaskStatus.PENDING:
      // Hourglass icon for pending
      return '<span class="fa fa-circle-pause" style="color: #ff9800;" title="Pending"></span>';

    case AsyncTaskStatus.DOING:
      // Spinner icon for processing
      return '<span class="fa fa-spinner fa-spin" style="color: #2196f3;" title="Processing"></span>';

    case AsyncTaskStatus.DONE:
      // Check circle icon for completed
      return '<span class="fa fa-check-circle" style="color: #4caf50;" title="Completed"></span>';

    case AsyncTaskStatus.FAILED:
    case AsyncTaskStatus.DEAD_LETTER:
    case AsyncTaskStatus.CANCELLED:
      // Bug icon for failed
      return '<span class="fa fa-bug" style="color: #f44336;" title="Failed"></span>';

    case AsyncTaskStatus.AWAITING_MEMORY:
      return '<span class="fa fa-clock" style="color: #78909C;" title="Awaiting Memory"></span>';

    case AsyncTaskStatus.SKIPPED:
      return '<span style="color: #bbb;" title="Skipped">—</span>';

    default:
      return '';
  }
}
